(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-search"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('faq-search'))customElements.define('faq-search',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;const input=this.querySelector('input');const update=()=>{const query=input.value.trim().toLocaleLowerCase();let matches=0;document.querySelectorAll('#MainContent .section-collapsible-text').forEach(group=>{let visible=0;group.querySelectorAll('.accordion').forEach(row=>{const match=!query||row.textContent.toLocaleLowerCase().includes(query);row.hidden=!match;if(match){visible++;matches++}if(query&&match)row.querySelector('details').open=true});group.closest('.shopify-section').hidden=visible===0});this.querySelector('[data-faq-empty]').hidden=matches!==0;document.dispatchEvent(new CustomEvent('faq:filter'))};input.addEventListener('input',update,{signal});this.querySelector('form').addEventListener('submit',event=>event.preventDefault(),{signal})}disconnectedCallback(){this.controller?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('product-slider')) return;
  customElements.define('product-slider', class extends customElements.get('slider-component') {
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(item => item.clientWidth > 0);
      if (!this.sliderItemsToShow.length) return;
      this.sliderItemOffset = this.sliderItemsToShow.length > 1
        ? this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
        : this.slider.clientWidth;
      if (!this.sliderItemOffset) return;
      this.slidesPerPage = Math.max(1, Math.round(this.slider.clientWidth / this.sliderItemOffset));
      this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      this.update();
    }
    update() {
      if (!this.sliderItemsToShow?.length || !this.sliderItemOffset) return;
      super.update();
      if (this.currentPageElement && this.pageTotalElement) {
        const pages = Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage);
        const page = Math.ceil((this.currentPage || 1) / this.slidesPerPage);
        this.currentPageElement.textContent = Math.max(1, Math.min(page, pages));
        this.pageTotalElement.textContent = pages;
      }
    }
    onButtonClick(event) {
      this.initPages();
      event.currentTarget.dataset.step = this.slidesPerPage || 1;
      super.onButtonClick(event);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onScroll();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        this.onScroll();
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      const headerBottom = this.headerBounds.bottom ?? this.header.offsetHeight;
      this.header.classList.toggle('scrolled-past-header', scrollTop > headerBottom);

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('image-tabs'))customElements.define('image-tabs',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;const tabs=[...this.querySelectorAll('[data-tab]')];const activate=tab=>{tabs.forEach(item=>{item.setAttribute('aria-selected',String(item===tab));item.tabIndex=item===tab?0:-1});this.querySelectorAll('[data-tab-panel]').forEach(panel=>panel.hidden=panel.dataset.tabPanel!==tab.dataset.tab)};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab),{signal});tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowDown'||event.key==='ArrowRight')next=tabs[(index+1)%tabs.length];if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=tabs[(index-1+tabs.length)%tabs.length];if(event.key==='Home')next=tabs[0];if(event.key==='End')next=tabs[tabs.length-1];if(next){event.preventDefault();activate(next);next.focus()}},{signal})});this.addEventListener('shopify:block:select',event=>{const tab=tabs.find(item=>item.dataset.tab===event.detail.blockId);if(tab)activate(tab)},{signal})}disconnectedCallback(){this.controller?.abort()}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
if(!customElements.get('article-contents'))customElements.define('article-contents',class extends HTMLElement{connectedCallback(){const content=this.closest('.article-template__body')?.querySelector('[data-article-body]');const list=this.querySelector('ol');if(!content||!list)return;list.replaceChildren();const headings=[...content.querySelectorAll('h2')].filter(heading=>!heading.closest('.py-journal-faq,.py-journal-author,.py-journal-callout'));if(!headings.length){this.hidden=true;return}headings.forEach((heading,index)=>{if(!heading.id)heading.id='ArticleHeading-'+this.closest('.shopify-section').id+'-'+index;const item=document.createElement('li');const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;item.append(link);list.append(item)})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('shopify:block:select', event => {
  if (!(event.target instanceof Element)) return;
  const block = event.target.closest('[data-product-info-block]');
  if (!block) return;
  const details = block.matches('details') ? block : block.querySelector('details');
  if (details) details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-with-image"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('campaign-newsletter')) {
  customElements.define('campaign-newsletter', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.querySelector('form').addEventListener('submit', event => this.subscribe(event), { signal: this.abortController.signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
    async subscribe(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button');
      if (button.disabled || !form.reportValidity()) return;
      const status = form.querySelector('[role="status"]');
      button.disabled = true;
      status.hidden = true;
      try {
        const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        });
        const result = await response.json();
        if (!response.ok || result.success === false) throw new Error(result.errors?.[0] || 'Unable to subscribe right now. Please try again.');
        form.reset();
        status.textContent = 'Thanks! Please check your inbox for your discount link.';
      } catch (error) {
        status.textContent = error.message || 'Unable to subscribe right now. Please try again.';
      } finally {
        status.hidden = false;
        button.disabled = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('customer-reviews'))customElements.define('customer-reviews',class extends HTMLElement{connectedCallback(){this.source=this.querySelector('[data-review-source]');this.cards=this.querySelector('[data-review-cards]');if(!this.source||!this.cards)return;const build=()=>{const reviews=[...this.source.querySelectorAll('.jdgm-carousel-item')];if(!reviews.length)return false;this.cards.replaceChildren();reviews.slice(0,3).forEach(review=>{const figure=document.createElement('figure');figure.className='customer-reviews__card';const stars=document.createElement('div');stars.className='customer-reviews__stars';const originalStars=review.querySelector('.jdgm-carousel-item__review-rating');if(originalStars)stars.append(...[...originalStars.childNodes].map(node=>node.cloneNode(true)));const title=document.createElement('h3');title.textContent=review.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim()||'';const quote=document.createElement('blockquote');quote.textContent=review.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim()||'';const footer=document.createElement('figcaption');const originalImage=review.querySelector('.jdgm-carousel-item__product-image');if(originalImage){const image=originalImage.cloneNode(true);image.removeAttribute('style');const source=image.dataset.src||image.getAttribute('src');if(source)image.src=source;if(image.dataset.srcRetina&&source)image.srcset=`${source} 1x, ${image.dataset.srcRetina} 2x`;image.loading='lazy';footer.append(image)}const author=document.createElement('div');const name=document.createElement('div');name.textContent=review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim()||'';author.append(name);if(originalImage?.alt){const product=document.createElement('p');product.textContent=originalImage.alt;author.append(product)}footer.append(author);figure.append(stars,title,quote,footer);this.cards.append(figure)});this.source.hidden=true;this.cards.hidden=false;return true};if(!build()){this.observer=new MutationObserver(()=>{if(build())this.observer.disconnect()});this.observer.observe(this.source,{childList:true,subtree:true})}}disconnectedCallback(){this.observer?.disconnect()}});

  } catch(e) { console.error(e); }
})();
})();
